import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaQuestionCircle } from 'react-icons/fa';

/**
 * InfoTooltip Component.
 * Renders a small question mark icon that shows a tooltip on hover.
 */
const InfoTooltip = ({ text, placement = "top" }) => {
    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props} className="opacity-100">
            {text}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement={placement}
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
        >
            <span className="text-secondary ms-1" style={{ cursor: 'help', verticalAlign: 'middle' }}>
                <FaQuestionCircle size={12} />
            </span>
        </OverlayTrigger>
    );
};

export default InfoTooltip;
